import { useQuery } from 'react-query';
import { authFetch } from '../../CommonUtils/authFetch';
import { queryKeys } from './queryKeys';

export interface TopDashboardData {
  id: number;
  name: string;
  total: number;
}

export interface DashboardDTO {
  completedPlans: number;
  heldAwayAccounts: number;
  heldAwayAssets: number;
  potentialAumFees: number;
  protectionGaps: number;
  topAssetGatheringOpportunities: TopDashboardData[];
  topClientsByInvestableAssets: TopDashboardData[];
  topLifeInsuranceOpportunities: TopDashboardData[];
}

const fetchDashboard = async (): Promise<DashboardDTO> => {
  return authFetch('/Adviser/adviser/Dashboard');
};

export const useDashboardQuery = () => {
  return useQuery(queryKeys.dashboard(), () => fetchDashboard(), {
    cacheTime: 0,
  });
};
